import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'app-identification-failed',
    templateUrl: './identification-failed.component.html',
    standalone: false
})
export class IdentificationFailedComponent implements OnInit {

  constructor(public translate: TranslateService) { }

  ngOnInit(): void { }

}
